import { render, staticRenderFns } from "./BiolinkCard.vue?vue&type=template&id=8547c0b8&scoped=true&"
import script from "./BiolinkCard.vue?vue&type=script&lang=js&"
export * from "./BiolinkCard.vue?vue&type=script&lang=js&"
import style0 from "./BiolinkCard.vue?vue&type=style&index=0&id=8547c0b8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8547c0b8",
  null
  
)

export default component.exports